import React from 'react';
import { buildImageSrcCandidates } from '@/utils/imageUrl';
import { useAppTranslation } from '@/i18n/useAppTranslation';

/**
 * Thử lần lượt các URL (proxy worker → lh3 → thumbnail → gốc) cho ảnh Drive/host chặn embed.
 */
export default function QuizRemoteImage({ rawUrl, questionId, className }) {
  const { t } = useAppTranslation();
  const candidates = React.useMemo(() => buildImageSrcCandidates(rawUrl), [rawUrl]);
  const [idx, setIdx] = React.useState(0);
  const driveId = React.useMemo(() => {
    const s = String(rawUrl || '');
    const m = s.match(/id=([a-zA-Z0-9_-]+)/i);
    return m?.[1] || null;
  }, [rawUrl]);

  React.useEffect(() => {
    setIdx(0);
  }, [questionId, rawUrl]);

  if (!rawUrl || candidates.length === 0) return null;

  const openHref = /^https?:\/\//i.test(String(rawUrl || '').trim())
    ? String(rawUrl).trim()
    : `https://${String(rawUrl || '').trim()}`;

  if (idx >= candidates.length) {
    return (
      <div className="space-y-3 p-4 text-sm text-[#434655]">
        <p>{t('common.remoteImageHelp')}</p>
        <a
          href={openHref}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#004ac6] underline break-all"
        >
          {t('common.openImageLink')}
        </a>
        {driveId ? (
          <div className="aspect-video w-full max-w-2xl overflow-hidden rounded-xl border border-[#c3c6d7] bg-black/5">
            <iframe
              title={t('common.imagePreviewTitle')}
              className="h-full min-h-[200px] w-full"
              src={`https://drive.google.com/file/d/${driveId}/preview`}
            />
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <img
      src={candidates[idx]}
      alt=""
      className={className}
      referrerPolicy="no-referrer"
      loading="lazy"
      onError={() => setIdx((i) => i + 1)}
    />
  );
}
